const emailActionTypes = {
  INVITE_LANDLORD: 'INVITE_LANDLORD',
  INVITE_USER: 'INVITE_USER',
  GET_INVITE_PROPERTY: 'GET_INVITE_PROPERTY',
  SET_INVITE_PROPERTY: 'SET_INVITE_PROPERTY',
  GET_INVITE_PROPERTY_PER_USER: 'GET_INVITE_PROPERTY_PER_USER',
  GET_ADMIN_INVITE_PROPERTY: 'GET_ADMIN_INVITE_PROPERTY',
  SET_ADMIN_INVITE_PROPERTY: 'SET_ADMIN_INVITE_PROPERTY',
};

export default emailActionTypes;
